export default "__VITE_ASSET__Tw8nMhxe__"